export default {
  ViewedVenue: 'Viewed Venue',
  ViewedEvent: 'Viewed Event',

  /* Account */
  LoggedIn: 'Logged In',
  LoggedOut: 'Logged Out',
  ForgotPassword: 'Forgot Password',
  SignedUp: 'Signed Up',
  AddedCreditCard: 'Added Credit Card',

  ViewedItem: 'Viewed Item',
  AddedItemToCart: 'Added Item To Cart',
  RemovedItem: 'Removed Item',
  StartedCheckoutItem: 'Started Checkout Item',
  StartedCheckout: 'Started Checkout',
  PurchasedItem: 'Purchased Item',
  BookingCompleted: 'Booking Completed',

  /* RESERVATION REQUESTS */
  ViewedReservationRequest: 'Viewed Reservation Request',
  ReservationRequested: 'Reservation Requested',

  /* GUESTLIST REQUESTS */
  ViewedGuestistRequest: 'Viewed Guestist Request',
  GuestlistRequested: 'Guestlist Requested',
}


// WEBPACK FOOTER //
// ./src/constants/trackingEvents.js